export default __webpack_public_path__ + "static/media/mur-soutainement.6299638d.png";